import {Injectable}                                                          from '@angular/core';
import {CrudPathDict, VapeDryConfIntf, VapeRecordLogIntf, VapeRecordSumIntf} from '@djsharkk/logr-types';
import {BehaviorSubject}                                                     from 'rxjs';
import {DataFirebaseBase}                                                    from './data-firebase.base';

@Injectable({
				providedIn: 'root'
			})
export class DataVapeService extends DataFirebaseBase<VapeRecordLogIntf, VapeRecordSumIntf> {
	protected paths: CrudPathDict = {
		log: 'vape_records_log',
		sum: 'vape_records_sum'
	};


	vapeConf = new BehaviorSubject<VapeDryConfIntf[]>([]);

	constructor() {
		super();
		this.svcFirebaseTools.recFetch<VapeDryConfIntf>('vape_conf').subscribe(conf => this.vapeConf.next(conf))
		this.records.sum.subscribe(records => {
			console.log('\n vape records');
			console.log(records)
		})
	}

	createRecord(record: VapeRecordLogIntf) {
		this.svcFirebaseTools.recCreate(this.paths.log, {
			...record,
			device: 'mighty'
		});
	}

	async updateRecord(record: VapeRecordLogIntf) {
		return await this.svcFirebaseTools.recUpdate(this.paths.log, record.id as string, {
			...record
		});
	}


}